import LoanDetails from './LoanDetails.container';
import withEmbeddedContext from '../../hoc/withEmbeddedContext';

export default withEmbeddedContext(LoanDetails);
